module.exports = __webpack_public_path__ + "static/toy_1-185c16e3ce2ded297c0ed8df15743ab2.jpg";